module.exports = __webpack_public_path__ + "img/resbtn.e40aa4fc.png";